import React, { useState, useRef, useCallback } from 'react';
import { Button } from 'react-bootstrap';

import { useUserContext } from 'providers/UserProvider';

import Table from 'components/common/Table';
import CreateManifestModal from 'components/add_order/manifest/CreateManifestModal';

import { manifestApi } from 'api';

import {
  getManifestListTab,
  getManifestListColumns,
  MANIFEST_FILTER_OPTIONS,
} from 'constants/manifest';

const Manifests = () => {
  const tableRef = useRef();
  const [showCreateManifestModal, setShowCreateManifestModal] = useState(false);

  const { selectedTenant, selectedWarehouse } = useUserContext();
  const tenant = selectedTenant?.domains?.[0]?.domain;
  const warehouse = selectedWarehouse?.domain;

  const initialFilter = { warehouse: selectedWarehouse?.id };

  const headerActions = (
    <Button
      variant="primary"
      size="sm"
      onClick={() => setShowCreateManifestModal(true)}
    >
      Create Manifest
    </Button>
  );

  const exportApi = useCallback(params => {
    return manifestApi.exportManifest(params);
  }, []);

  const handleCreateSuccess = () => {
    tableRef.current?.refetch();
  };

  return (
    <>
      <Table
        ref={tableRef}
        title="Manifests"
        apiService={manifestApi}
        exportApi={exportApi}
        sortable={true}
        columns={getManifestListColumns(tenant, warehouse)}
        filterOptions={MANIFEST_FILTER_OPTIONS}
        tabOptions={getManifestListTab(initialFilter)}
        initialFilter={initialFilter}
        headerActions={headerActions}
      />

      <CreateManifestModal
        show={showCreateManifestModal}
        onHide={() => setShowCreateManifestModal(false)}
        onSuccess={handleCreateSuccess}
      />
    </>
  );
};

export default Manifests;
